// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ProductType } from '../Instruments/ProductType';
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
// Мессадж форекс-клиента
export class DirectOrderDialogMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_CANCEL_ORDER_MESSAGE);
        this.ProductType = ProductType.General;
        this.dialogId = 0;
        this.orderId = null;
        this.boundToOrderId = null;
        this.price = 0;
        this.comment = null;
        this.orderType_Renamed_Field = 0;
        this.closeTime = null;
        this.cancelTime = null;
        this.FAccount = null;
        this.orderStatus = 0;
        this.clientOrderId = '';
        this.quantity = 0;
        this.lastAmount = null;
        this.disClosedQuantity = null;
        this.sharesFilled = 0;
    }
    get DialogId() {
        return this.dialogId;
    }
    set DialogId(val) {
        this.dialogId = val;
    }
    get OrderId() {
        return this.orderId;
    }
    set OrderId(val) {
        this.orderId = val;
    }
    get BoundToOrderId() {
        return this.boundToOrderId;
    }
    set BoundToOrderId(val) {
        this.boundToOrderId = val;
    }
    get Price() {
        return this.price;
    }
    set Price(val) {
        this.price = val;
    }
    get Comment() {
        return this.comment;
    }
    set Comment(val) {
        this.comment = val;
    }
    get OrderType() {
        return this.orderType_Renamed_Field;
    }
    set OrderType(val) {
        this.orderType_Renamed_Field = val;
    }
    get CloseTime() {
        return this.closeTime;
    }
    set CloseTime(val) {
        this.closeTime = val;
    }
    get CancelTime() {
        return this.cancelTime;
    }
    set CancelTime(val) {
        this.cancelTime = val;
    }
    get Account() {
        return this.FAccount;
    }
    set Account(val) {
        this.FAccount = val;
    }
    get OrderStatus() {
        return this.orderStatus;
    }
    set OrderStatus(val) {
        this.orderStatus = val;
    }
    get ClientOrderId() {
        return this.clientOrderId;
    }
    set ClientOrderId(val) {
        this.clientOrderId = val;
    }
    get Quantity() {
        return this.quantity;
    }
    set Quantity(val) {
        this.quantity = val;
    }
    get LastAmount() {
        return this.lastAmount;
    }
    set LastAmount(val) {
        this.lastAmount = val;
    }
    get DisClosedQuantity() {
        return this.disClosedQuantity;
    }
    set DisClosedQuantity(val) {
        this.disClosedQuantity = val;
    }
    get SharesFilled() {
        return this.sharesFilled;
    }
    set SharesFilled(val) {
        this.sharesFilled = val;
    }
}
